import React from "react";
import Nav from "../../common/Nav";
import Footer from "../../common/Footer";

const MyMembership = () => {
  // Sample membership data
  const membershipData = {
    memberFrom: "2023-01-01",
    memberTill: "2024-01-01",
    availableStays: 5,
    membershipType: "Gold",
  };

  return (
    <div>
        <div className="p-6">
            <Nav/>
        </div>
    <div className="min-h-screen bg-gray-100 mt-12 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-8">My Membership</h1>

        {/* Membership Details */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h2 className="text-xl font-semibold mb-4">Membership Details</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-gray-500">Member From</p>
              <p className="font-medium">{membershipData.memberFrom}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Member Till</p>
              <p className="font-medium">{membershipData.memberTill}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Available Stays</p>
              <p className="font-medium">{membershipData.availableStays}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Membership Type</p>
              <p className="font-medium">{membershipData.membershipType}</p>
            </div>
          </div>
        </div>

        {/* How to Use Membership */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h2 className="text-xl font-semibold mb-4">How to Use Membership</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>Book stays using your membership credits.</li>
            <li>Enjoy exclusive discounts on partner hotels.</li>
            <li>Access premium customer support.</li>
            <li>Upgrade your plan for additional benefits.</li>
          </ul>
        </div>

        {/* Upgrade Plan */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h2 className="text-xl font-semibold mb-4">Upgrade Plan</h2>
          <p className="mb-4">
            Upgrade to a higher membership plan for more benefits and stays.
          </p>
          <button className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 transition duration-300">
            Upgrade Now
          </button>
        </div>

        {/* Contact Customer Care */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold mb-4">Contact Customer Care</h2>
          <p className="mb-4">
            For any queries or assistance, reach out to our customer care team.
          </p>
          <button className="bg-green-500 text-white px-6 py-2 rounded-md hover:bg-green-600 transition duration-300">
            Contact Us
          </button>
        </div>
      </div>
    </div>
    <Footer/>
    </div>
  );
};

export default MyMembership;